import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './SupplierInventory.module.scss';
import Search from '../../common/Search';
import ProductFilter from '../../filters/ProductFilter';
import { datetimeFormatter } from '../../../utils/formatHelper';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { sortCaret, sizePerPageRenderer, paginationTotalRenderer } from '../../../utils/tableHelper';
import { useMixpanel } from 'react-mixpanel-browser';
import { reportBusinessActionToMixpanel } from '../../../utils/reportBusinessActionToMixpanel';
import { StaticFilters } from '../../../constants/staticFilters';
function SupplierInventory(props) {
  const { data, count, offset, perPage } = props;

  const onPageChange = (page, sizePerPage) => {
    props.setPage((page - 1) * perPage);
  };

  const onSizePerPageChange = (sizePerPage) => {
    props.setPerPage(sizePerPage);
  };

  const onSortChange = (name, order) => {
    props.setOrderField(name);
    props.setOrder(order);
  };

  const noDataIndication = () => `There is no data to display`;

  const selectRowOptions = {
    hideSelectColumn: true,
    mode: 'radio',
    clickToSelect: true,
    onSelect: props.onOpenHistoryLog,
  };

  const pagination = paginationFactory({
    page: offset / perPage + 1,
    sizePerPage: perPage,
    sizePerPageList: [20, 50, 100],
    onPageChange: onPageChange,
    onSizePerPageChange: onSizePerPageChange,
    totalSize: count,
    showTotal: true,
    sizePerPageRenderer,
    paginationTotalRenderer,
  });

  const mixpanel = useMixpanel();
  const reportBi = (event) => {
    reportBusinessActionToMixpanel(mixpanel, event);
  };

  const onTableChange = (type, newstate) => {
    const eventName = `inventory-page-sort-table-by-${newstate.sortField}`;
    reportBi(eventName);
  };

  const columns = [
    {
      text: 'Id',
      dataField: 'id',
      hidden: true,
    },
    {
      text: 'Model',
      dataField: 'model',
      sort: true,
      onSort: onSortChange,
    },
    {
      text: 'SKU',
      dataField: 'sku',
      sort: true,
      onSort: onSortChange,
    },
    {
      text: 'Name',
      dataField: 'title',
      sort: true,
      onSort: onSortChange,
    },
    {
      text: 'UPC',
      dataField: 'upc',
      sort: true,
      onSort: onSortChange,
    },
    {
      text: 'EAN',
      dataField: 'ean',
      onSort: onSortChange,
      sort: true,
    },
    {
      text: 'Total Units',
      dataField: 'available_inventory',
      sort: true,
      onSort: onSortChange,
    },
    {
      text: 'Last Update',
      dataField: 'last_inventory_update',
      sort: true,
      onSort: onSortChange,
      formatter: (cell) => (cell ? datetimeFormatter(cell) : ''),
      classes: 'clickable',
    },
  ];

  return (
    <div className="row vertical-indent">
      <div className="column_filter">
        <Search
          searchQuery={props.searchQuery}
          search={props.productSearch}
          title="Search Inventory"
          placeholder="Search"
          setTooltip={{
            placement: 'bottom',
            content: 'Model / SKU / Name / UPC / EAN',
          }}
        />
        <ProductFilter
          filters={props.filters}
          currentFilters={props.currentFilters}
          staticFilters={[
            StaticFilters.VARIANTS_HAS_INVENTORY,
            StaticFilters.VARIANT_IS_APPROVED,
            StaticFilters.ACTIVE_PRODUCTS,
          ]}
          currentFilterSearches={props.currentFilterSearches}
          setFilter={props.setFilter}
          setFilterSearch={props.setFilterSearch}
          showCount={false}
        />
      </div>

      <div className={cn('column_products', styles.table)}>
        <BootstrapTable
          columns={columns}
          data={data}
          keyField="id"
          printable
          striped
          hover
          bordered={false}
          pagination={pagination}
          remote={{
            pagination: true,
            sort: true,
          }}
          selectRow={selectRowOptions}
          defaultSorted={[
            {
              dataField: props.orderField || 'sku',
              order: props.order || 'desc',
            },
          ]}
          defaultSortDirection={props.order || 'desc'}
          sort={{
            sortCaret: sortCaret,
          }}
          onTableChange={onTableChange}
          noDataIndication={noDataIndication}
        ></BootstrapTable>
      </div>
    </div>
  );
}

export default SupplierInventory;

SupplierInventory.defaultProps = {
  isLoadingProducts: false,
};

SupplierInventory.propTypes = {
  data: PropTypes.array.isRequired,
  setFilter: PropTypes.func,
  setFilterSearch: PropTypes.func,
  perPage: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  productSearch: PropTypes.func.isRequired,
  searchQuery: PropTypes.string.isRequired,
  offset: PropTypes.number.isRequired,
  isLoadingProducts: PropTypes.bool,
};
